import { useState, useEffect, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { createBrowserHistory } from "history";

import { UserContext } from "@src/App";
import { increment, decrement, historyLen } from "@src/@slice/historySlice";
import toast from "@src/utils/toast";
import usePartnerLike from "@src/utils/hooks/usePartnerLike";

import Icon from "@src/components/common/icons/Icon";

import styles from "./partnerDetailHeader.module.scss";

const PartnerDetailHeader = (props: {
  partnerName: string;
  shareLink: string;
  partnerUuid: string;
  isLike: number | null;
  partnerType: number;
  hasClose?: boolean;
}) => {
  const { partnerName, shareLink, partnerUuid, isLike, partnerType, hasClose = false } = props;

  const user = useContext(UserContext);
  const history = createBrowserHistory();
  const historyLength = useSelector(historyLen);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { updatePartnerLikeFromServer, showPartnerLikeToast } = usePartnerLike();

  const [currentLike, setCurrentLike] = useState(!!isLike);

  useEffect(() => {
    switch (history.action) {
      case "PUSH":
        dispatch(increment());
        break;
      case "POP":
        if (historyLength > 0) dispatch(decrement());
        break;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [history]);

  const goBack = () => {
    if (historyLength >= 1 || user.me === null) {
      navigate(-1);
    } else {
      window.location.href = "h2mwbell://webview/close";
    }
  };

  const sharePartner = () => {
    window.location.href = `h2mwbell://share?title=${partnerName}&msg=${shareLink}`;
  };

  const toggleLike = async () => {
    try {
      // 업체리스트 페이지 좋아요 상태 변경을 위함
      const likeChangedPartnerUuid = partnerUuid;
      if (!!isLike !== currentLike) {
        localStorage.removeItem("likeChangedPartnerUuid");
      } else {
        localStorage.setItem("likeChangedPartnerUuid", likeChangedPartnerUuid);
      }
      setCurrentLike(!currentLike);
      await updatePartnerLikeFromServer(partnerUuid, currentLike);
      showPartnerLikeToast(partnerType, currentLike);
    } catch (error) {
      console.error("postPartnerLike", error);
      toast.showErrorSnackbar("오류가 발생했습니다.");
    }
  };

  return (
    <header
      id="partner-detail-header-component"
      className={styles["partner-detail-header-component"]}
    >
      <div className="safe-area"></div>

      <div className={styles["inner"]}>
        <div className={styles["left-panel"]}>
          <button onClick={goBack} className="btn btn-icon">
            <Icon name="Back" size={40} />
          </button>
          <h2 className={styles["partner-name"]}>{partnerName}</h2>
        </div>

        <div className={styles["right-panel"]}>
          <button onClick={sharePartner} className="btn btn-icon">
            <Icon name="Share" size={40} />
          </button>

          <button onClick={toggleLike} className="btn btn-icon">
            {currentLike === true ? (
              <Icon name="LikeFill" size={40} />
            ) : (
              <Icon name="Like" size={40} />
            )}
          </button>

          {hasClose && (
            <button onClick={goBack} className="btn btn-icon">
              <Icon name="Close" size={40} />
            </button>
          )}
        </div>
      </div>
    </header>
  );
};

export default PartnerDetailHeader;
